import { AddPlayerToGroupByEmailRequest, ICreateGroupPlayers } from "@grassrootly/api/entities";
import { provider } from "@grassrootly/api/providers";

export const AddPlayerToGroupByEmail = async (params: AddPlayerToGroupByEmailRequest): Promise<boolean> =>
  provider.Request("/groups/{groupId}/add-player-to-group-by-email", params);
